export function generateChromaName(str) {
    console.log('user input: ' + str);
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap chars
    var from = "àáäâèéëêìíïîòóöôùúüûñçľščťžýéď·,:;";
    var to   = "aaaaeeeeiiiioooouuuunclsctzyed----";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    console.log("final str:" + str);
    return str;
}